export class ProjectProgressInfo {
  Id:number
  ProjectId: number
  ProjectCode: string
  ProjectProgress: number
  ProjectSummary: string
  ProjectCompleted: string
  ProjectOnGoing: string
  ProjectUpComing: string
  UpdateDate: string
  UpdateBy: string
  CreateDate: string
  CreateBy: string
}
